import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ItemGroup } from '@/components/ui/item';

import { useConsignmentAttachments } from '../model/use-consignment-attachments';
import type { AttachmentsData } from '../model/types';
import { AttachmentItem } from './attachment-item';

interface AttachmentListProps {
  consignmentId?: string;
  onAttachmentsChange?: (attachments: AttachmentsData) => void;
}

export function AttachmentList({ consignmentId, onAttachmentsChange }: AttachmentListProps) {
  const { t } = useTranslation();

  const attachmentsData = useConsignmentAttachments({
    consignmentId
  });

  const { attachments, isLoading, handleDownload, handleRemove, isLocalAttachment } = attachmentsData;

  useEffect(() => {
    onAttachmentsChange?.(attachmentsData);
  }, [attachmentsData, onAttachmentsChange]);

  if (isLoading) {
    return <div className="text-sm text-muted-foreground">{t('common.loading')}</div>;
  }

  if (attachments.length === 0) return null;

  return (
    <ItemGroup>
      {attachments.map((attachment) => {
        const key = isLocalAttachment(attachment) ? attachment.tempId : `server-${attachment.id}`;

        return (
          <AttachmentItem
            key={key}
            attachment={attachment}
            onDownload={handleDownload}
            onRemove={isLocalAttachment(attachment) ? handleRemove : undefined}
            isLocal={isLocalAttachment(attachment)}
          />
        );
      })}
    </ItemGroup>
  );
}
